import { getRecipes, getRecipeDetails, getAllRecipes } from "./recipes";
import { registerUser, loginUser, loginWithGoogle, completeOAuthLogin, isUserLoggedIn, logoutUser, requestPasswordReset, resetPassword, getProfile, updateProfile, changePassword, requestEmailChange, verifyEmailChange } from "./users";
import { getPreferences, savePreferences } from "./preferences";
import { getCurrentMenu, saveWeeklyMenu } from "./menus";
import {
  createShoppingList,
  getCurrentShoppingList,
  sendCurrentShoppingListEmail,
  getSupportedShoppingSupermarkets,
  updateShoppingListItem,
} from "./shopping-lists";
import { getGenericIngredientsByIds } from "./generic-ingredients";
import {
  createOrder,
  cancelOrder,
  getOrders,
  getOrderById,
  getCheckoutSession,
  getCheckoutSessionByOrder,
} from "./orders";
import { getAddresses, saveAddress, deleteAddress, autocompleteAddress } from "./addresses";

const logic = {
  // RECIPES
  getRecipes,
  getRecipeDetails,
  getAllRecipes,

  // USERS
  registerUser,
  loginUser,
  loginWithGoogle,
  completeOAuthLogin,
  isUserLoggedIn,
  logoutUser,
  requestPasswordReset,
  resetPassword,
  getProfile,
  updateProfile,
  changePassword,
  requestEmailChange,
  verifyEmailChange,

  // PREFERENCES
  getPreferences,
  savePreferences,

  // MENUS
  getCurrentMenu,
  saveWeeklyMenu,

  // SHOPPING LISTS
  createShoppingList,
  getCurrentShoppingList,
  sendCurrentShoppingListEmail,
  getSupportedShoppingSupermarkets,
  updateShoppingListItem,
  getGenericIngredientsByIds,

  // ORDERS
  createOrder,
  cancelOrder,
  getOrders,
  getOrderById,
  getCheckoutSession,
  getCheckoutSessionByOrder,

  // ADDRESSES
  getAddresses,
  saveAddress,
  deleteAddress,
  autocompleteAddress,
};

export default logic;
